import client from '@lib/http/client'

export const markAsRead = ({ identifiers }: { identifiers: string[] }) =>
  client.post(`leads/mark-as-read`, { leads: identifiers })
